<template>
  <v-container >

    <v-row>
      <v-col sm="12" md="6">
        <v-img
            :lazy-src="this.puzzleProduct.attributes.extraSmallImageSrc"
            :src="this.puzzleProduct.attributes.mediumImageSrc"
            class="grey darken-4"
            aspect-ratio="1"
        ></v-img>
      </v-col>
      <v-col sm="12" md="6">
        <h2>{{this.puzzleProduct.attributes.name}}</h2>
        <p>by {{getBrandName()}}</p>
        <themes :puzzle-product-id="puzzle_product_id"></themes>
        <div class="d-flex mt-4">
          <v-rating class="custom-rating"
                    color="yellow darken-1"
                    background-color="gray"
                    half-increments
                    length="5"
                    value="0"
                    dense
                    size="18"
                    readonly
                    :value="parseFloat(this.puzzleProduct.attributes.rating)"
          ></v-rating>
          ({{this.puzzleProduct.attributes.rating}})
        </div>
        <div v-html="this.puzzleProduct.attributes.description" class="mt-4 mb-4"></div>

        <ratings-sub-disiplay :puzzle-product="this.puzzleProduct"></ratings-sub-disiplay>

        <div class="mt-4" v-if="ownPuzzleOrderId">
          <ratings-display :puzzle-order-id="ownPuzzleOrderId"></ratings-display>
        </div>

      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="12">
        <h3>Member Reviews</h3>
        <div v-if="memberReviews.length == 0" class="grey--text mt-2">
          No member reviews yet.
        </div>
        <div v-for="review in memberReviews" :key="review.id" class="mt-4">
          <div class="d-flex align-center">
            <v-rating
                color="yellow darken-1"
                background-color="gray"
                half-increments
                length="5"
                value="0"
                dense
                size="16"
                readonly
                :value="parseFloat(review.attributes.rating)"
            ></v-rating>
            <span class="ml-2 grey--text text-caption">{{getDateString(review.attributes.reviewedAt)}}</span>
          </div>
          <div v-if="review.attributes.reviewText">
            {{review.attributes.reviewText}}
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ratingsDisplay from "./history/ratings_display.vue";
import ratingsSubDisiplay from "./wishlist/ratings_sub_display.vue";
import themes from "./wishlist/themes.vue"
import subscriptionService from "../api/subscription-service";

export default {
  name: 'puzzle',
  components: {
    ratingsSubDisiplay,
    ratingsDisplay,
    themes
  },
  computed: {
    ...mapState({
      puzzles: 'puzzles',
      puzzleProducts: 'puzzleProducts',
    }),
    ...mapGetters({
      puzzleOrders: 'getPuzzleOrders',
      brands: 'getBrands',
      activeSubscriptionId: 'getActiveSubscriptionId',
      hasReviewsFeature: 'hasReviewsFeature',
    }),
    puzzleProduct: function() {
      return this.puzzleProducts[this.puzzle_product_id]
    },
    ownPuzzleOrderId: function() {
      for (let index in this.puzzleOrders) {
        let puzzleOrder = this.puzzleOrders[index];
        let puzzle = this.puzzles[puzzleOrder.attributes.puzzleId];
        if (puzzle && puzzle.attributes.puzzleProductId == this.puzzle_product_id) {
          return puzzleOrder.id;
        }
      }
      return null;
    }
  },
  watch: {
    hasReviewsFeature: {
      handler(value) {
        if (value === false) {
          this.$router.replace('/portal/subscriptions/'+this.activeSubscriptionId+'/home')
        }
      },
      immediate: true
    }
  },
  mounted: function(){
    subscriptionService.getPuzzleProductReviews(this.puzzle_product_id, data => {
      let reviews = data.puzzleHistories ? Object.values(data.puzzleHistories) : [];
      reviews.sort((a, b) => new Date(b.attributes.reviewedAt) - new Date(a.attributes.reviewedAt));
      this.memberReviews = reviews;
    })
  },
  methods: {
    getBrandName: function(){
      return this.brands[this.puzzleProduct.attributes.brandId].attributes.name;
    },
    getDateString: function(date){
      let d = new Date(date);
      return d.toLocaleDateString();
    }
  },
  data: function(){
    return {
      memberReviews: []
    }
  },
  props: {
    puzzle_product_id: null
  }
}
</script>
